export const Home = '/';